export const PaginationSortingMixin = {
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10
      },
      total: 0,
    }
  },
  computed: {
    paginationOptions () {
      let pagination = {}

      let itemsPerPage = this.options.itemsPerPage
      if(itemsPerPage !== undefined) {
        pagination["itemsperpage"] = itemsPerPage
      }

      let page = this.options.page
      if(page !== undefined) {
        pagination["page"] = page
      }
      return pagination
    },
    sortingOptions () {
      let sorting = {}

      let sortBy = this.options.sortBy
      let sortDesc = this.options.sortDesc

      if(sortBy !== undefined && sortBy.length > 0) {
        sorting["ordering"] = sortBy[0]

        if(sortDesc !== undefined && sortDesc.length > 0 && sortDesc[0] == true) {
          sorting["ordering"] = "-" + sorting["ordering"]
        }
      }

      return sorting
    },
  },
  methods: {
    getContentRange(headers){
      let contentRange = headers.get("content-range")
      if (contentRange !== null) {
        let match = contentRange.match(new RegExp("([0-9]+)-([0-9]+)\/([0-9]+)"));
        if (match !== null){
          return match.slice(1).map(Number)
        }
      }
      return null
    },
    getTotal(response) {
      let contentRange = this.getContentRange(response.headers)
      if(contentRange !== null){
        return contentRange[2]
      }
      return null
    }
  },
  watch: {
    options: {
      handler () {
        this.get()
      },
      immediate: true,
      deep: true
    },
  },
}
